<script lang="ts">
    import inputfields from "./"
    export let subField: TaskStepField
    export let value: any = {}
    export let fullPath: string
    if (!value) value = {}
    if (!value[subField.pathInDb]) value[subField.pathInDb] = null
    let internalValue = subField.pathInDb
        ? JSON.parse(JSON.stringify(value[subField.pathInDb]))
        : JSON.parse(JSON.stringify(value))
    $: value = subField.pathInDb ? { ...value, [subField.pathInDb]: internalValue } : internalValue
</script>

<svelte:component
    this="{inputfields[subField.widget]}"
    fullPath="{subField.pathInDb ? `${fullPath}.${subField.pathInDb}` : fullPath}"
    field="{subField}"
    bind:value="{internalValue}"
/>
